import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { api_url } from "../utils/config";

const PaymentReceipt = () => {
  const navigate = useNavigate();
  const [txRef, setTxRef] = useState("");
  const [orderId, setOrderId] = useState("");
  const [status, setStatus] = useState("processing");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const ref = params.get("tx_ref") || params.get("trx_ref") || "";
    const order =
      params.get("orderId") || localStorage.getItem("orderId") || "";

    setTxRef(ref);
    setOrderId(order);

    if (ref) {
      localStorage.setItem("chapaTxRef", ref);
    }

    const verify = async () => {
      if (!ref) {
        setStatus("failed");
        return;
      }

      try {
        const { data } = await axios.get(
          `${api_url}/api/payment/chapa/verify/${ref}`,
        );
        if (data.payment_status === "paid") {
          setStatus("paid");
        } else {
          setStatus("failed");
        }
      } catch (error) {
        console.error("Receipt verification error:", error);
        // A return URL alone is not proof of payment. Do not display a paid
        // receipt when verification cannot be completed.
        setStatus("failed");
      }
    };

    verify();
  }, []);

  const handleDone = async () => {
    if (orderId) {
      try {
        await axios.get(`${api_url}/api/order/confirm/${orderId}`);
      } catch (error) {
        console.error("Order confirm error:", error);
      }
      localStorage.removeItem("orderId");
    }

    navigate("/dashboard/my-orders", { replace: true });
  };

  if (status === "processing") {
    return (
      <div className="w-screen h-screen flex items-center justify-center bg-slate-50">
        <div className="text-center text-slate-600">
          <div className="animate-spin h-10 w-10 border-4 border-green-500 border-t-transparent rounded-full mx-auto mb-4" />
          <p>Checking payment receipt...</p>
        </div>
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="w-screen h-screen flex items-center justify-center bg-slate-50 px-4">
        <div className="bg-white shadow-lg rounded-lg p-8 max-w-md text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">
            Payment failed
          </h2>
          <Link
            to="/dashboard/my-orders"
            className="inline-block bg-green-600 text-white px-5 py-2 rounded-sm"
          >
            Back to orders
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="w-screen min-h-screen flex items-center justify-center bg-slate-50 px-4 py-10">
      <div className="w-full max-w-lg bg-white shadow-lg rounded-lg p-6 text-slate-700">
        <div className="text-center mb-6">
          <div className="mx-auto mb-3 flex h-16 w-16 items-center justify-center rounded-full bg-green-100 text-2xl text-green-600">
            ✓
          </div>
          <h2 className="text-2xl font-bold text-slate-800">Payment Receipt</h2>
        </div>

        <div className="space-y-3 border-t border-b border-slate-200 py-4 text-sm">
          <div className="flex justify-between">
            <span>Status</span>
            <span className="font-semibold text-green-600">Paid</span>
          </div>
          <div className="flex justify-between">
            <span>Order ID</span>
            <span className="font-medium">{orderId || "-"}</span>
          </div>
          <div className="flex justify-between">
            <span>Reference</span>
            <span className="font-medium break-all">{txRef || "Chapa"}</span>
          </div>
        </div>

        <div className="mt-6 flex flex-col gap-3">
          {txRef && (
            <a
              href={`https://checkout.chapa.co/checkout/test-payment-receipt/${encodeURIComponent(txRef)}`}
              target="_blank"
              rel="noreferrer"
              className="w-full text-center bg-indigo-600 hover:bg-indigo-700 text-white font-medium rounded-sm px-4 py-3"
            >
              View Chapa receipt
            </a>
          )}

          <button
            onClick={handleDone}
            className="w-full bg-green-600 hover:bg-green-700 text-white font-medium rounded-sm px-4 py-3"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default PaymentReceipt;
